/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateTBankPaymentMutationRequest, CreateTBankPaymentMutationResponse, CreateTBankPayment400, CreateTBankPayment401, CreateTBankPayment404, CreateTBankPayment500 } from "../entities/CreateTBankPayment";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createTBankPayment } from "../api/createTBankPayment";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createTBankPaymentMutationKey = () => [{ url: '/api/v1/payments/tbank' }] as const

export type CreateTBankPaymentMutationKey = ReturnType<typeof createTBankPaymentMutationKey>

export function createTBankPaymentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateTBankPaymentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createTBankPaymentMutationKey()
        return mutationOptions<CreateTBankPaymentMutationResponse, ResponseErrorConfig<CreateTBankPayment400 | CreateTBankPayment401 | CreateTBankPayment404 | CreateTBankPayment500>, {data: CreateTBankPaymentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createTBankPayment(data, config)
          },
        })

}

/**
 * @description Создает новый платеж через платежную систему T-Bank.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 240 RUB
 * - Максимальная сумма платежа: 9000 RUB
 * - Максимальная длина description: 140 символов
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Создание записи в БД
 * 3. Отправка запроса в T-Bank API
 * 4. Возврат URL для оплаты
 * @summary Инициализация платежа через T-Bank
 * {@link /api/v1/payments/tbank}
 */
export function useCreateTBankPayment<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateTBankPaymentMutationResponse, ResponseErrorConfig<CreateTBankPayment400 | CreateTBankPayment401 | CreateTBankPayment404 | CreateTBankPayment500>, {data: CreateTBankPaymentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateTBankPaymentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createTBankPaymentMutationKey()

          const baseOptions = createTBankPaymentMutationOptions(config) as UseMutationOptions<CreateTBankPaymentMutationResponse, ResponseErrorConfig<CreateTBankPayment400 | CreateTBankPayment401 | CreateTBankPayment404 | CreateTBankPayment500>, {data: CreateTBankPaymentMutationRequest}, TContext>
          

          return useMutation<CreateTBankPaymentMutationResponse, ResponseErrorConfig<CreateTBankPayment400 | CreateTBankPayment401 | CreateTBankPayment404 | CreateTBankPayment500>, {data: CreateTBankPaymentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateTBankPaymentMutationResponse, ResponseErrorConfig<CreateTBankPayment400 | CreateTBankPayment401 | CreateTBankPayment404 | CreateTBankPayment500>, {data: CreateTBankPaymentMutationRequest}, TContext>
      
}